import React from "react";
import { motion } from "framer-motion";

const Programs = ({ onOpenAssessment }) => {
  const items = [
    { 
      img: "/Programs/p1.png", 
      title: "Web Development for Age 9 and above", 
      text: "JavaScript and Python Programming — projects that build portfolio and confidence." 
    },
    { 
      img: "/Programs/p2.jpg",
      title: "Maths Support & Remedials", 
      text: "Targeted coaching for gaps, exam prep, and confidence building." 
    },
    { 
      img: "/Programs/p3.jpg",
      title: "Software Engineering", 
      text: "Introduction to web development, software architecture and cloud hosting." 
    },
    { 
      img: "/Programs/p4.jpg",
      title: "Language Learning", 
      text: "English, German, and French." 
    },
    { 
      img: "/Programs/p5.png", 
      title: "Computer Appreciation (All Ages)", 
      text: "For all ages. An exclusive for adults struggling with computer use." 
    },
    { 
      img: "/Programs/p6.jpg",
      title: "Smart Electronic Invitation", 
      text: "Modern event e-invites with RSVP tracking under our Smart Invite brand." 
    },
    { 
      img: "/Programs/p7.jpg",
      title: "Software Development Services", 
      text: "Custom software solutions for various needs and projects." 
    },
  ];

  return (
    <section id="programs" className="py-20">
      <div className="max-w-7xl mx-auto px-6">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          viewport={{ once: true }} 
          className="text-3xl md:text-4xl font-extrabold text-indigo-900"
        >
          Programs at Dosh Coding Academy
        </motion.h2>
        <p className="text-gray-600 mt-2 max-w-3xl">
          We teach future-ready skills for every stage—kids, teens, and adults.
        </p>

        <div className="mt-10 grid md:grid-cols-3 gap-6">
          {items.map((p) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="p-6 rounded-2xl border bg-white hover:shadow-lg transition flex flex-col"
            >
              {/* Image */}
              <img 
                src={p.img} 
                alt={p.title} 
                className="w-full h-40 object-cover rounded-xl mb-4" 
              />
              
              <h3 className="font-semibold text-indigo-900">{p.title}</h3>
              <p className="text-gray-600 text-sm mt-1 flex-1">{p.text}</p>
              <div className="mt-4">
                <button 
                  onClick={onOpenAssessment} 
                  className="text-indigo-700 font-semibold hover:underline"
                >
                  Learn more →
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Programs;
